export default __webpack_public_path__ + "static/media/m_news.79951192.png";